import * as React from 'react'

export const SendFoxIcon = (props: any) =>
<svg viewBox="0 0 19.5 22.1"
  xmlns="http://www.w3.org/2000/svg"
  className={`system-icon ${props.className}`}
>
  <path d="M0 11l9.8 8.8 9.7-8.8v11.1H0z" fill="#ccdfed"/>
  <g fill="#ff644d"><path d="M0 7.9l9.8 8.9 9.7-8.9zM13.3 5.6h6.2V0zM0 0v5.6h6.2z"/></g></svg>
